import React from "react";
import "../../styles/HomeSection/HomeSection.scss";
import { HomeSectionImage } from "./HomeSectionImage";
import { HomeSectionButtons } from "./HomeSectionButtons";
import { useTranslation } from "react-i18next";

const HomeSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="Home-section" id="HomeSection">
      <h1>
        <span>{t("we")}</span> {t("offerSpaces")} {t("forBussinesses")}
      </h1>

      <HomeSectionButtons />
      <HomeSectionImage />
    </section>
  );
};

export default HomeSection;
